import * as React from 'react'
import Form, { ISubmitEvent } from 'react-jsonschema-form'
import {
    UIResetPasswordFormSchema, getResetPasswordFormSchema } from '../../../Model/ResetPasswordForm'
import { Button } from 'react-bootstrap'
import LocalizationStore from '../../../Stores/LocalizationStore'
import HttpActionsService from '../../../Services/HttpActionsService'

export default class ResetyPasswordPage extends React.Component<any> {

    constructor(props: any) {
        super(props)
    }

    uiSchema: any = UIResetPasswordFormSchema

    reset(e: ISubmitEvent<any>): void {
        HttpActionsService.getInstance().resetPassword(e.formData['email'])
    }

    render() {
        const self = this
        const ls = LocalizationStore.getInstance()

        return (
            <div className="recoveryPasswordPage">
                <Form
                    onSubmit={(e) => self.reset(e)}
                    schema={getResetPasswordFormSchema()}
                    uiSchema={this.uiSchema}
                >
                    <Button type="submit">{ls.t!('ResetPasswordBtn')}</Button>
                </Form>
            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/Pages/Account/ResetPasswordPage.tsx